import styled from "styled-components";
import { FlexColumn, FlexRow } from "styles/layout";
import { Theme } from "theme";

export const RostersContainer = styled(FlexRow)`
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-around;
  column-gap: 15px;
`;

export const RosterContainer = styled(FlexColumn)<{ hoverColor?: string }>`
  width: 200px;
  @media (max-width: 1100px) {
    width: 190px;
  }

  @media (max-width: 850px) {
    width: 200px;
  }

  @media (max-width: 700px) {
    width: 180px;
  }

  @media (max-width: 600px) {
    width: 200px;
  }

  @media (max-width: 450px) {
    width: 180px;
  }

  @media (max-width: 400px) {
    width: 250px;
  }
`;

export const RosterDisplayNameContainer = styled(FlexRow)`
  padding: 4px ${Theme.smallPanelPadding};
  font-weight: 600;
  font-size: 11.5pt;

  @media (max-width: 700px) {
    font-size: 11pt;
  }
`;

export const OrgLogoContainer = styled.div`
  min-width: 22px;
  max-width: 22px;
  height: 24px;
`;

export const OrgName = styled.span`
  flex: 1;
  min-width: 0;
  margin-left: 4px;
  white-space: nowrap;
  overflow-x: clip;
  text-overflow: ellipsis;
`;

export const RosterDriversContainer = styled(FlexColumn)`
  border-top: ${Theme.panelContentBorder};
`;

export const DriverContainer = styled(FlexRow)`
  padding: 2px 8px;
  font-size: 11pt;
  color: ${Theme.panelForegroundLight};
  border-left: 2px solid ${Theme.tabSelectedForeground};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;

  @media (max-width: 700px) {
    font-size: 10pt;
  }
`;
